<router-outlet></router-outlet>
<ngx-spinner name="mainSpinner" bdOpacity="0.1" bdColor="rgba(51,51,51,0.34)" size="medium" color="#fff"
		type="ball-clip-rotate" [fullScreen]="true">
</ngx-spinner>
